var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCaratRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 10 19",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.430087 16.1948L6.87009 9.7548C7.07009 9.5548 7.07009 9.2448 6.87009 9.0448L0.430088 2.6148C0.340088 2.5248 0.280087 2.3948 0.280087 2.2648L0.280087 0.844796C0.280087 0.394796 0.820087 0.174796 1.13009 0.494796L9.69009 9.0548C9.89009 9.2548 9.89009 9.5648 9.69009 9.7648L1.13009 18.3248C0.820087 18.6348 0.280087 18.4148 0.280087 17.9748L0.280087 16.5648C0.280087 16.4348 0.330087 16.3048 0.430087 16.2148L0.430087 16.1948Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaratRight);
export default __webpack_public_path__ + "static/media/IconCaratRight.578d81df75606195c5169580aeb9c176.svg";
export { ForwardRef as ReactComponent };